/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/components/sap-hcm/SapHcmInboundConfigEditDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SapHcmInboundConfigEditDialogTestIds = {
  btnCancelSapHcmConfig: "btn-cancel-sap-hcm-config",
  btnSaveSapHcmConfig: "btn-save-sap-hcm-config",
  inputSapHcmEmployeeKeyField: "input-sap-hcm-employee-key-field",
  inputSapHcmValidityEndField: "input-sap-hcm-validity-end-field",
  inputSapHcmValidityStartField: "input-sap-hcm-validity-start-field",
  sapHcmValiditySelect: "sap-hcm-validity-select",
  selectSapHcmAuthType: "select-sap-hcm-auth-type"
} as const;
